module.exports = __webpack_public_path__ + "static/media/product1.d61927bf.jpg";